import { VAlert } from 'vuetify/lib/components/VAlert';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VContainer, {
    staticClass: "n20-container",
    attrs: {
      "fluid": ""
    }
  }, [_c('core-header', {
    attrs: {
      "headline": _vm.$i18n_t('Common.fmTicketsMgmtHead'),
      "subtitle": _vm.$i18n_t('Common.fmTicketsMgmtHeadInfoText')
    }
  }), _c(VRow, {
    staticClass: "n20-mainrow",
    staticStyle: {
      "min-width": "0"
    }
  }, [_c(VCol, [_vm.dialog ? _c('core-n20-dialog', {
    attrs: {
      "isOpen": _vm.isOpen,
      "max-width": "900"
    },
    on: {
      "close": function ($event) {
        return _vm.close();
      }
    },
    scopedSlots: _vm._u([{
      key: "title",
      fn: function () {
        return [_vm._v("\n          " + _vm._s(_vm.formTitle) + "\n        ")];
      },
      proxy: true
    }, {
      key: "buttons",
      fn: function () {
        return [_c('core-button', {
          attrs: {
            "color": _vm.color,
            "title": _vm.$i18n_t('Common.save'),
            "prepend-icon": "fa-save"
          },
          on: {
            "click": _vm.save
          }
        }, [_vm._v("\n            " + _vm._s(_vm.$i18n_t('Common.save')) + "\n          ")])];
      },
      proxy: true
    }], null, false, 3512454896),
    model: {
      value: _vm.dialog,
      callback: function ($$v) {
        _vm.dialog = $$v;
      },
      expression: "dialog"
    }
  }, [_vm.editedItem.fileURL ? _c('img', {
    staticClass: "grey lighten-2 image-preview",
    staticStyle: {
      "object-fit": "contain",
      "margin-top": "30px"
    },
    attrs: {
      "src": _vm.editedItem.fileURL
    }
  }) : _vm._e(), _c(VContainer, {
    staticClass: "pt-0"
  }, [_c(VRow, {
    staticClass: "px-0"
  }, [_c(VCol, {
    staticClass: "py-2",
    attrs: {
      "cols": "12"
    }
  }, [_vm._v(_vm._s(_vm.editedItem.subject) + " - " + _vm._s(_vm.editedItem.properties.dTwin.title))])], 1), _c(VRow, {
    staticClass: "px-0"
  }, [_c(VCol, {
    staticClass: "py-2",
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('core-dateTime-picker', {
    attrs: {
      "from": _vm.editedItem.closedDate / 1000,
      "expandIcon": "",
      "allowNull": "",
      "dateOnly": "",
      "hideBorderOnCollapse": ""
    },
    on: {
      "date:picked": _vm.closedDatePicked
    },
    scopedSlots: _vm._u([{
      key: "header",
      fn: function ({
        startDate
      }) {
        return [_c(VTextField, {
          attrs: {
            "value": startDate,
            "color": _vm.color,
            "label": _vm.$i18n_t('Common.closedDate'),
            "append-icon": "fal fa-calendar-day",
            "readonly": "",
            "disabled": "",
            "hide-details": ""
          }
        })];
      }
    }], null, false, 3548125187)
  })], 1), _c(VCol, {
    staticClass: "py-2",
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c(VSelect, {
    attrs: {
      "items": _vm.state,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "menu-props": {
        top: true,
        offsetY: true
      },
      "label": _vm.$i18n_t('Common.state'),
      "color": _vm.color,
      "name": "State",
      "hide-details": ""
    },
    model: {
      value: _vm.editedItem.status,
      callback: function ($$v) {
        _vm.$set(_vm.editedItem, "status", $$v);
      },
      expression: "editedItem.status"
    }
  })], 1), _c(VCol, {
    staticClass: "py-2",
    attrs: {
      "cols": "12"
    }
  }, [_c(VTextarea, {
    attrs: {
      "label": _vm.$i18n_t('Common.comment'),
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "color": _vm.color,
      "name": "comment",
      "value": "",
      "hint": "",
      "hide-details": ""
    },
    model: {
      value: _vm.newComment.comment,
      callback: function ($$v) {
        _vm.$set(_vm.newComment, "comment", $$v);
      },
      expression: "newComment.comment"
    }
  })], 1)], 1)], 1)], 1) : _vm._e(), _c('core-n20Card', {
    attrs: {
      "title": _vm.$i18n_t('Common.ticketsTableHead')
    }
  }, [_c(VRow, {
    staticStyle: {
      "width": "100%"
    }
  }, [_c(VCol, {
    staticClass: "pt-6 pb-0",
    attrs: {
      "cols": "6"
    }
  }, [_c('p', [_vm._v("\n              " + _vm._s(_vm.$i18n_t('Common.ticketsTableText')) + "\n            ")])]), _c(VCol, {
    staticClass: "pt-0 pb-0",
    staticStyle: {
      "text-align": "right"
    },
    attrs: {
      "cols": "6"
    }
  }, [_vm.items.length > 0 ? _c(VTextField, {
    attrs: {
      "color": _vm.color,
      "label": _vm.$i18n_t('Common.search'),
      "append-icon": "fal fa-search",
      "single-line": "",
      "clearable": "",
      "hide-details": "",
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled
    },
    model: {
      value: _vm.search,
      callback: function ($$v) {
        _vm.search = $$v;
      },
      expression: "search"
    }
  }) : _vm._e()], 1)], 1), _c(VCardText, {
    staticClass: "pl-0 pr-0"
  }, [_c(VDataTable, {
    class: {
      mobile: _vm.isMobile
    },
    attrs: {
      "color": _vm.color,
      "headers": _vm.tableLocalizations.headers,
      "items": _vm.items,
      "search": _vm.search,
      "loading": _vm.tableLoading,
      "loading-text": _vm.$i18n_t('Common.loading'),
      "footer-props": _vm.tableLocalizations.footerProps,
      "expanded": _vm.expanded,
      "sort-by": "createdAt",
      "item-key": "id",
      "page": _vm.tableOptions.page,
      "options": _vm.tableOptions
    },
    on: {
      "update:expanded": function ($event) {
        _vm.expanded = $event;
      },
      "update:page": function ($event) {
        return _vm.$set(_vm.tableOptions, "page", $event);
      },
      "update:options": function ($event) {
        _vm.tableOptions = $event;
      }
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function (props) {
        return [!_vm.isMobile ? _c('tr', [_c('td', {
          on: {
            "click": function ($event) {
              _vm.expanded = _vm.shouldExpand(props.item) ? [props.item] : [];
            }
          }
        }, [props.item.status == 2 ? _c('span', [_c(VIcon, {
          staticClass: "state-done"
        }, [_vm._v("fal fa-check-circle")])], 1) : _vm._e(), props.item.status == 1 ? _c('span', [_c(VIcon, {
          staticClass: "state-in-progress"
        }, [_vm._v("fal fa-wrench")])], 1) : _vm._e(), props.item.status == 0 ? _c('span', [_c(VIcon, {
          staticClass: "state-to-do"
        }, [_vm._v("fal fa-bell")])], 1) : _vm._e()]), _c('td', {
          on: {
            "click": function ($event) {
              _vm.expanded = _vm.shouldExpand(props.item) ? [props.item] : [];
            }
          }
        }, [_vm._v(_vm._s(props.item.subject))]), _c('td', {
          on: {
            "click": function ($event) {
              _vm.expanded = _vm.shouldExpand(props.item) ? [props.item] : [];
            }
          }
        }, [_vm._v("\n                  " + _vm._s(props.item.statusUi.text) + "\n                ")]), _c('td', {
          on: {
            "click": function ($event) {
              _vm.expanded = _vm.shouldExpand(props.item) ? [props.item] : [];
            }
          }
        }, [props.item.type ? _c('div', [_vm._v("\n                    " + _vm._s(props.item.type.name) + "\n                  ")]) : _c('div', [_vm._v("-")])]), _c('td', {
          on: {
            "click": function ($event) {
              _vm.expanded = _vm.shouldExpand(props.item) ? [props.item] : [];
            }
          }
        }, [props.item.properties && props.item.properties.dTwin ? _c('div', [_vm._v("\n                    " + _vm._s(props.item.properties.dTwin.title) + "\n                  ")]) : _vm._e()]), _c('td', {
          on: {
            "click": function ($event) {
              _vm.expanded = _vm.shouldExpand(props.item) ? [props.item] : [];
            }
          }
        }, [props.item.comments && props.item.comments.length ? _c('div', {
          staticClass: "text-truncate",
          staticStyle: {
            "width": "200px"
          }
        }, [_vm._v("\n                    " + _vm._s(props.item.lastComment) + "\n                  ")]) : _c('div', [_vm._v("-")])]), _c('td', {
          on: {
            "click": function ($event) {
              _vm.expanded = _vm.shouldExpand(props.item) ? [props.item] : [];
            }
          }
        }, [_vm._v("\n                  " + _vm._s(_vm.date(props.item.createdAt)) + "\n                ")]), _c('td', {
          staticClass: "text-right"
        }, [_vm.permissions['IsFmTicket.manage'] ? _c('span', [_c(VIcon, {
          attrs: {
            "color": _vm.color,
            "small": ""
          },
          on: {
            "click": function ($event) {
              return _vm.editTicket(props.item);
            }
          }
        }, [_vm._v("fal fa-edit")])], 1) : _vm._e()]), _c('td', {
          staticClass: "text-right"
        }, [_vm.permissions['IsFmTicket.manage'] ? _c('span', [_c(VIcon, {
          attrs: {
            "color": _vm.color,
            "small": ""
          },
          on: {
            "click": function ($event) {
              return _vm.confirmDeleteTicket(props.item);
            }
          }
        }, [_vm._v("fal fa-trash-alt")])], 1) : _vm._e()])]) : _c('tr', [_c('td', {
          staticStyle: {
            "padding": "0px"
          },
          on: {
            "click": function ($event) {
              _vm.expanded = _vm.shouldExpand(props.item) ? [props.item] : [];
            }
          }
        }, [_c('ul', {
          staticClass: "flex-content",
          staticStyle: {
            "padding-left": "0px"
          }
        }, [_c('li', {
          staticClass: "flex-item",
          attrs: {
            "data-label": "Icon"
          }
        }, [props.item.status == 0 ? _c('span', [_c(VIcon, {
          staticClass: "state-to-do",
          attrs: {
            "size": "20"
          }
        }, [_vm._v("fal fa-bell")])], 1) : _vm._e(), props.item.status == 1 ? _c('span', [_c(VIcon, {
          staticClass: "state-in-progress",
          attrs: {
            "size": "20"
          }
        }, [_vm._v("fal fa-wrench")])], 1) : _vm._e(), props.item.status == 2 ? _c('span', [_c(VIcon, {
          staticClass: "state-done",
          attrs: {
            "size": "20"
          }
        }, [_vm._v("fal fa-check-circle")])], 1) : _vm._e()]), _c('li', {
          staticClass: "flex-item"
        }, [_c('span', {
          staticClass: "flex-item-label"
        }, [_vm._v(_vm._s(_vm.$i18n_t('Common.subject')))]), _c('br'), _c('span', {
          staticClass: "flex-item-content"
        }, [_vm._v(_vm._s(props.item.subject))])]), _c('li', {
          staticClass: "flex-item"
        }, [_c('span', {
          staticClass: "flex-item-label"
        }, [_vm._v(_vm._s(_vm.$i18n_t('Common.type')))]), _c('br'), _c('span', {
          staticClass: "flex-item-content"
        }, [_vm._v(_vm._s(props.item.type.name))])]), _c('li', {
          staticClass: "flex-item"
        }, [_c('span', {
          staticClass: "flex-item-label"
        }, [_vm._v(_vm._s(_vm.$i18n_t('Common.state')))]), _c('br'), _c('span', {
          staticClass: "flex-item-content"
        }, [_vm._v(_vm._s(props.item.statusUi.text))])]), _c('li', {
          staticClass: "flex-item"
        }, [_c('span', {
          staticClass: "flex-item-label"
        }, [_vm._v(_vm._s(_vm.$i18n_t('Common.dTwin')))]), _c('br'), _c('span', {
          staticClass: "flex-item-content"
        }, [_vm._v(_vm._s(props.item.properties.dTwin.title))])]), _c('li', {
          staticClass: "flex-item"
        }, [_c('span', {
          staticClass: "flex-item-label"
        }, [_vm._v(_vm._s(_vm.$i18n_t('Common.createdDate')))]), _c('br'), _c('span', {
          staticClass: "flex-item-content"
        }, [_vm._v(_vm._s(_vm.date(props.item.createdAt)))])])])])])];
      }
    }, {
      key: "expanded-item",
      fn: function (props) {
        return [_c('tr', [_c('td', {
          staticClass: "pa-4",
          attrs: {
            "colspan": "10"
          }
        }, [_c(VCard, {
          staticClass: "d-inline-block mx-auto",
          attrs: {
            "elevation": "5"
          }
        }, [_c(VContainer, [_c(VRow, {
          attrs: {
            "justify": "space-between"
          }
        }, [props.item.properties.fileId ? _c(VCol, {
          attrs: {
            "cols": "auto"
          }
        }, [_c('img', {
          staticClass: "grey lighten-2 elevation-3",
          attrs: {
            "src": _vm.getImageURL(props.item.properties.fileId),
            "width": _vm.isMobile ? 200 : 400
          }
        })]) : _vm._e(), _c(VCol, {
          staticClass: "pt-0",
          attrs: {
            "cols": "auto"
          }
        }, [_c(VRow, {
          staticClass: "flex-column mr-7 ml-5"
        }, [_c(VCol, {
          attrs: {
            "cols": "auto"
          }
        }, [_vm.canReadUsers && _vm.authorNames[props.item.authorId] ? _c('span', [_vm._v("\n                                " + _vm._s(_vm.$i18n_t('IS.FM.Ticket.author')) + "\n                                "), _c('a', {
          on: {
            "click": function ($event) {
              return _vm.editAuthor(props.item.authorId);
            }
          }
        }, [_vm._v("\n                                  " + _vm._s(_vm.authorNames[props.item.authorId]) + "\n                                ")])]) : _vm._e()])], 1), _vm._l(props.item.comments, function (val, index) {
          return _c(VRow, {
            key: index,
            staticClass: "flex-column mr-7 ml-5"
          }, [_c(VCol, {
            staticClass: "pb-0 font-weight-medium",
            attrs: {
              "cols": "auto"
            }
          }, [_vm._v("\n                              " + _vm._s(_vm.$i18n_t('Common.comment')) + " " + _vm._s(_vm.date(val.createdAt, true)) + "\n                            ")]), _c(VCol, {
            staticClass: "pb-0",
            attrs: {
              "cols": "auto"
            }
          }, [_vm._v("\n                              " + _vm._s(val.comment) + "\n                            ")]), _c(VDivider, {
            staticClass: "mt-3 mb-1"
          })], 1);
        })], 2)], 1)], 1)], 1)], 1)])];
      }
    }, {
      key: "footer.page-text",
      fn: function (props) {
        return [_c(VRow, {
          staticClass: "text-center align-center"
        }, [_c(VCol, {
          attrs: {
            "cols": "7",
            "md": "7"
          }
        }, [_vm._v("\n                  " + _vm._s(props.pageStart) + "-" + _vm._s(props.pageStop) + " " + _vm._s(_vm.$i18n_t('Common.of')) + " " + _vm._s(props.itemsLength) + "\n                ")]), _c(VCol, {
          attrs: {
            "cols": "5",
            "md": "5"
          }
        }, [_c('niota-classic-common-table-page-selector', {
          attrs: {
            "page": _vm.tableOptions.page,
            "table-max-items": props.itemsLength,
            "table-items-per-page": _vm.tableOptions.itemsPerPage,
            "title-txt": _vm.$i18n_t('Common.goToPage')
          },
          on: {
            "page-change": function ($event) {
              return _vm.setCurrentTablePage($event);
            }
          }
        })], 1)], 1)];
      }
    }, !_vm.tableLoading ? {
      key: "no-data",
      fn: function () {
        return [_c(VAlert, {
          staticClass: "mb-1",
          attrs: {
            "value": true,
            "color": "transparent",
            "icon": "fal fa-comment-exclamation"
          }
        }, [_vm._v("\n                " + _vm._s(_vm.$i18n_t('Common.SorryNothingToDisplay')) + "\n              ")])];
      },
      proxy: true
    } : null], null, true),
    model: {
      value: _vm.selected,
      callback: function ($$v) {
        _vm.selected = $$v;
      },
      expression: "selected"
    }
  })], 1)], 1)], 1)], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };